// extracted by mini-css-extract-plugin
export default {"list":"AlertCenterList_list__A6ty6","listIsEmpty":"AlertCenterList_listIsEmpty__rLIft"};